import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

export const responsivePagePaddingX = {
  xs: 2,
  sm: 3,
  md: 4,
} as const;

export const defaultResponsiveContentMaxWidth = 1200;

export const responsiveFillColumnSx: SystemStyleObject<Theme> = {
  width: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
};
